import DisplayPreviewManager from "../../Managers/DisplayPreviewManager";

import RemoteDevicePreviewManager from "../../Managers/RemoteDevicePreviewManager";

import VideoExternalPreviewManager from "../../Managers/VideoExternalPreviewManager";

import VideoPreviewManager from "../../Managers/VideoPreviewManager";

import WebCamPreviewManager from "../../Managers/WebCamPreviewManager";

class PlayerFactory {
  constructor() {}

  private getRootElement() {
    return document.querySelector("#area") as HTMLElement;
  }

  get(
    id: string,
  ): HTMLVideoElement | HTMLImageElement | HTMLCanvasElement | null {
    const root = this.getRootElement();

    if (!root) return null;

    // Browser sources already have a GPU canvas. Compose it directly instead of
    // scheduling it through the MediaStream video sink a second time.
    const browserCanvas = document.getElementById(`browser-capture-${id}`);
    if (browserCanvas instanceof HTMLCanvasElement && root.contains(browserCanvas)) {
      return browserCanvas;
    }

    const element = root.querySelector(`video#${id}, img#${id}`) as
      | HTMLVideoElement
      | HTMLImageElement
      | HTMLCanvasElement
      | null;

    return element;
  }

  getAll(): (HTMLVideoElement | HTMLImageElement | HTMLCanvasElement)[] {
    const root = this.getRootElement();

    if (!root) return [];

    const resources = Array.from(root.querySelectorAll("video, img, canvas"));

    return [...resources] as (
      | HTMLVideoElement
      | HTMLImageElement
      | HTMLCanvasElement
    )[];
  }

  delete(id: string) {
    const video = this.get(id);

    if (!video) return;

    video.remove();
  }

  /**
   * Libera las fuentes de un área específica (eviction del pool keep-alive del
   * SceneCompositor): saca el <video> del DOM y frena el stream cacheado en los
   * managers que cachean por área (cámara/display/dispositivo remoto). Los managers
   * de video local/externo no abren hardware → no hace falta tocarlos acá.
   */

  release(id: string) {
    WebCamPreviewManager.destroy(id);

    DisplayPreviewManager.destroy(id);

    RemoteDevicePreviewManager.destroy(id);

    this.delete(id);
  }

  destroy() {
    const videos = this.getAll();

    VideoPreviewManager.destroy();

    VideoExternalPreviewManager.destroy();

    WebCamPreviewManager.destroy();

    DisplayPreviewManager.destroy();

    RemoteDevicePreviewManager.destroy();

    for (const video of videos) {
      video.remove();
    }
  }
}

export default PlayerFactory;
